const revealSelectors = [
  'main .pk-sec > *:not(.section-background)',
  'main .pk-sec [class*="__item"]',
  'main .pk-sec [class*="__card"]',
  'main .pk-sec [class*="__col"]',
  'main .pk-sec [class*="__media"]',
  'main .product-information',
  'main .product-recommendations',
].join(',');

const excludedSelectors = [
  '.pk-ugc__scroll',
  '.pk-crafted__track',
  '.pk-crafted__modal',
  '.section-background',
  '[data-no-scroll-reveal]',
  '[hidden]',
].join(',');

const reducedMotionQuery = window.matchMedia('(prefers-reduced-motion: reduce)');
let observer;
let mutationObserver;
let queued = false;

function getRevealCandidates(root = document) {
  if (!(root instanceof Document || root instanceof Element)) return [];

  const candidates = root.matches?.(revealSelectors)
    ? [root, ...root.querySelectorAll(revealSelectors)]
    : [...root.querySelectorAll(revealSelectors)];

  return candidates.filter((element) => {
    if (!(element instanceof HTMLElement)) return false;
    if (element.matches(excludedSelectors) || element.closest(excludedSelectors)) return false;
    if (element.closest('#header-group, header, [role="dialog"], [data-reel-modal]')) return false;
    return !element.dataset.scrollReveal;
  });
}

function addRevealCandidates(root = document) {
  const candidates = getRevealCandidates(root);
  if (!candidates.length) return;

  candidates.forEach((element, index) => {
    const direction = index % 5 === 1 ? 'left' : index % 5 === 3 ? 'right' : index % 5 === 4 ? 'scale' : 'up';
    element.dataset.scrollReveal = direction;
    element.style.setProperty('--scroll-reveal-delay', `${Math.min(index % 5, 3) * 70}ms`);

    if (reducedMotionQuery.matches) {
      element.dataset.scrollRevealed = 'true';
    } else {
      observer?.observe(element);
    }
  });
}

function initializeReveal() {
  if (!('IntersectionObserver' in window)) {
    getRevealCandidates().forEach((element) => {
      element.dataset.scrollReveal = 'up';
      element.dataset.scrollRevealed = 'true';
    });
    return;
  }

  observer = new IntersectionObserver(
    (entries) => {
      entries.forEach((entry) => {
        if (!entry.isIntersecting) return;
        entry.target.dataset.scrollRevealed = 'true';
        observer.unobserve(entry.target);
      });
    },
    { threshold: 0.12, rootMargin: '0px 0px -8% 0px' },
  );

  addRevealCandidates();

  mutationObserver = new MutationObserver(() => {
    if (queued) return;
    queued = true;
    requestAnimationFrame(() => {
      queued = false;
      addRevealCandidates();
    });
  });

  mutationObserver.observe(document.querySelector('main') || document.body, {
    childList: true,
    subtree: true,
  });
}

if (document.readyState === 'loading') {
  document.addEventListener('DOMContentLoaded', initializeReveal, { once: true });
} else {
  initializeReveal();
}
